import { render, staticRenderFns } from "./_Transfer.vue?vue&type=template&id=aa121aec&"
import script from "./_Transfer.vue?vue&type=script&lang=js&"
export * from "./_Transfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports